// extracted by mini-css-extract-plugin
module.exports = {"bleed":"checkout-form-light_bleed__3Iv_F","column":"checkout-form-light_column__2_5_G"};